import React from "react";

export const InstagramIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.1425 7.80849C21.8466 7.80849 21.6068 7.56864 21.6068 7.27277C21.6068 6.97691 21.8466 6.73706 22.1425 6.73706"
                stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M22.1426 7.80849C22.4385 7.80849 22.6783 7.56864 22.6783 7.27277C22.6783 6.97691 22.4385 6.73706 22.1426 6.73706"
                stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M1.83911 7.35295C1.83911 4.30789 4.30763 1.83936 7.35271 1.83936H22.0557C25.1007 1.83936 27.5693 4.30789 27.5693 7.35295V22.0559C27.5693 25.1009 25.1007 27.5695 22.0557 27.5695H7.35271C4.30763 27.5695 1.83911 25.1009 1.83911 22.0559V7.35295Z"
                stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M14.7043 20.1686C17.7221 20.1686 20.1686 17.7221 20.1686 14.7043C20.1686 11.6864 17.7221 9.23999 14.7043 9.23999C11.6864 9.23999 9.23999 11.6864 9.23999 14.7043C9.23999 17.7221 11.6864 20.1686 14.7043 20.1686Z"
                stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
}